import React, { useState } from "react";

/* ---------- UI COMPONENTS ---------- */

const Section = ({ title }) => (
  <div style={{ marginTop: 24, marginBottom: 10, fontWeight: 800, fontSize: 15, color: "#6366f1" }}>
    {title}
  </div>
);

const Field = ({ label, value, isDark }) => (
  <div
    style={{
      padding: "10px 12px",
      borderRadius: 10,
      background: isDark ? "rgba(255,255,255,0.04)" : "rgba(99,102,241,0.05)",
      border: isDark ? "1px solid rgba(255,255,255,0.06)" : "1px solid rgba(99,102,241,0.1)",
    }}
  >
    <div style={{ fontSize: 11, opacity: 0.6 }}>{label}</div>
    <div style={{ fontSize: 13, fontWeight: 600 }}>{value || "—"}</div>
  </div>
);

const FileView = ({ label, doc, isDark, onPreview }) => {
  const isImage = doc?.fileUrl?.match(/\.(jpg|jpeg|png|webp)$/i);

  return (
    <div
      style={{
        padding: "10px 12px",
        borderRadius: 10,
        background: isDark ? "rgba(255,255,255,0.04)" : "rgba(99,102,241,0.05)",
        border: isDark ? "1px solid rgba(255,255,255,0.06)" : "1px solid rgba(99,102,241,0.1)",
      }}
    >
      <div style={{ fontSize: 11, opacity: 0.6 }}>{label}</div>

      {doc?.fileUrl ? (
        isImage ? (
          <div
            onClick={() => onPreview(doc.fileUrl)}
            style={{ fontSize: 12, fontWeight: 700, color: "#6366f1", cursor: "pointer" }}
          >
            🖼 View Image
          </div>
        ) : (
          <a
            href={doc.fileUrl}
            target="_blank"
            rel="noreferrer"
            style={{ fontSize: 12, fontWeight: 700, color: "#6366f1", textDecoration: "none" }}
          >
            📄 Open File
          </a>
        )
      ) : (
        <span style={{ fontSize: 12, opacity: 0.4 }}>Not Uploaded</span>
      )}
    </div>
  );
};

/* ---------- MAIN COMPONENT ---------- */

const ViewForm = ({ caseData, isDark, onClose }) => {
  const [previewImg, setPreviewImg] = useState(null); // ✅ correct position

  if (!caseData) return null;

  const d = caseData || {};
  const docs = caseData.documents || [];

  const getDoc = (type) =>
    docs.find((doc) => doc.documentType?.toLowerCase() === type.toLowerCase());

  const yesNo = (val) => {
  if (val === true || val === "Yes" || val === "yes" || val === 1) return "Yes";
  return "No";
};

  return (
    <div className="cw-slideIn" style={{ display: "flex", flexDirection: "column", height: "100%" }}>

      {/* HEADER */}
      <div
        style={{
          padding: "22px 20px 18px",
          borderLeft: "4px solid #6366f1",
          background: isDark
            ? "linear-gradient(135deg, rgba(99,102,241,0.15), transparent)"
            : "linear-gradient(135deg, rgba(99,102,241,0.08), transparent)",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <div style={{ fontSize: 28 }}>📋</div>
            <div style={{ fontSize: 17, fontWeight: 800, color: "#6366f1" }}>
              View Form
            </div>
          </div>

          <button
            onClick={onClose}
            style={{
              width: 36,
              height: 36,
              borderRadius: 12,
              cursor: "pointer",
              background: isDark
                ? "rgba(255,255,255,0.06)"
                : "rgba(99,102,241,0.08)",
              border: "1px solid rgba(99,102,241,0.2)",
              color: isDark ? "#fff" : "#6366f1",
            }}
          >
            ✕
          </button>
        </div>
      </div>

      {/* BODY */}
      <div style={{ padding: 20, overflowY: "auto" }}>

        {/* DRIVER */}
        <Section title="Driver Details" />
        <div className="cw-form-grid">
          <Field label="Driver Name" value={d.driverName} isDark={isDark} />
          <Field label="Driver Phone Number" value={d.driverNumber} isDark={isDark} />
          <Field label="Driver DL Number" value={d.driverDlNumber} isDark={isDark} />
          <Field label="Driver DOB" value={d.driverDob} isDark={isDark} />

          <FileView label="Driver DL Front" doc={getDoc("DRIVER_LICENSE_FRONT")} isDark={isDark} onPreview={setPreviewImg} />
          <FileView label="Driver DL Back" doc={getDoc("DRIVER_LICENSE_BACK")} isDark={isDark} onPreview={setPreviewImg} />
          <FileView label="Driver Aadhaar" doc={getDoc("DRIVER_AADHAAR")} isDark={isDark} onPreview={setPreviewImg} />
        </div>

        {/* VEHICLE */}
        <Section title="Vehicle Documents" />
        <div className="cw-form-grid">
          <FileView label="RC Image" doc={getDoc("rc")} isDark={isDark} onPreview={setPreviewImg} />
          <FileView label="NP (5 Year)" doc={getDoc("permit_5_year")} isDark={isDark} onPreview={setPreviewImg} />
          <FileView label="NP (1 Year)" doc={getDoc("np_1_year")} isDark={isDark} onPreview={setPreviewImg} />
          <FileView label="Fitness" doc={getDoc("fitness")} isDark={isDark} onPreview={setPreviewImg} />
          <FileView label="PUCC Image" doc={getDoc("pucc")} isDark={isDark} onPreview={setPreviewImg} />
          <FileView label="Vehicle Tax Document" doc={getDoc("vehicle_tax")} isDark={isDark} onPreview={setPreviewImg} />
        </div>

        {/* HELPER */}
        <Section title="Helper / Co-Pilot" />
        <div className="cw-form-grid">
          <Field label="Helper Present" value={yesNo(d.helperPresent)} isDark={isDark} />

          {yesNo(d.helperPresent) === "Yes" && (
            <>
              <Field label="Helper Name" value={d.helperName} isDark={isDark} />
              <Field label="Co-Pilot DL Number" value={d.helperDlNumber} isDark={isDark} />
<Field label="Co-Pilot DOB" value={d.helperDob} isDark={isDark} />
              <Field label="Helper Phone" value={d.helperNumber} isDark={isDark} />
            </>
            
          )}
        </div>

        {/* ACCIDENT */}
        <Section title="Accident Information" />
        <div className="cw-form-grid">
          <Field label="Accident Date & Time" value={d.accidentDate} isDark={isDark} />
          <Field label="FIR Number" value={d.firNumber} isDark={isDark} />
          <Field label="Vehicle Loaded" value={yesNo(d.isLoaded)} isDark={isDark} />
          <FileView label="LR Image" doc={getDoc("lr_image")} isDark={isDark} onPreview={setPreviewImg} />
          <Field label="FIR Date" value={d.firOrGdDate} isDark={isDark} />
          <Field label="Third Party Loss" value={yesNo(d.thirdPartyLoss)} isDark={isDark} />
          </div>

{/* 🔥 ROOT CAUSE BIG BOX */}
<div style={{ marginTop: 16 }}>
  <div
    style={{
      fontSize: 13,
      fontWeight: 700,
      marginBottom: 6,
      color: isDark ? "#c7d2fe" : "#4f46e5",
    }}
  >
    Root Cause / How Accident Happened
  </div>

  <div
    style={{
      padding: "12px 14px",
      borderRadius: 12,
      fontSize: 13,
      lineHeight: 1.6,
      minHeight: 120,
      whiteSpace: "pre-wrap",
      background: isDark
        ? "rgba(255,255,255,0.05)"
        : "rgba(99,102,241,0.06)",
      border: isDark
        ? "1px solid rgba(255,255,255,0.08)"
        : "1px solid rgba(99,102,241,0.12)",
      color: isDark ? "#e2e8f0" : "#1e1b4b",
    }}
  >
    {d.rootCause || "No description provided"}
  </div>
</div>     
        {/* ACCIDENT IMAGES */}
        <Section title="Accident Images" />
        <div className="cw-form-grid">
          <FileView label="Front Left" doc={getDoc("ACCIDENT_FRONT_LEFT")} isDark={isDark} onPreview={setPreviewImg} />
          <FileView label="Front Right" doc={getDoc("ACCIDENT_FRONT_RIGHT")} isDark={isDark} onPreview={setPreviewImg} />
          <FileView label="Right Side" doc={getDoc("ACCIDENT_RIGHT_SIDE")} isDark={isDark} onPreview={setPreviewImg} />
          <FileView label="Left Side" doc={getDoc("ACCIDENT_LEFT_SIDE")} isDark={isDark} onPreview={setPreviewImg} />
          <FileView label="Back Left" doc={getDoc("ACCIDENT_BACK_LEFT")} isDark={isDark} onPreview={setPreviewImg} />
          <FileView label="Back Right" doc={getDoc("ACCIDENT_BACK_RIGHT")} isDark={isDark} onPreview={setPreviewImg} />
        </div>

        {/* CLAIM */}
        <Section title="Claim Details" />
        <div className="cw-form-grid">
          <Field label="Claim Number" value={d.claimNumber} isDark={isDark} />
          <Field label="Insurance Company" value={d.insuranceCompany} isDark={isDark} />
          <Field label="Policy Number" value={d.policyNumber} isDark={isDark} />
          <Field label="Vehicle Release Date" value={d.vehicleReleaseDate} isDark={isDark} />
          <Field label="Jamanti Date" value={d.jamantiDate} isDark={isDark} />
        </div>

        {/* ADVOCATE */}
        <Section title="Advocate / Power of Attorney" />
        <div className="cw-form-grid">
          <Field label="Advocate Needed" value={yesNo(d.isAdvocateNeeded)} isDark={isDark} />

          {yesNo(d.isAdvocateNeeded) === "Yes" && (
            <>
              <Field label="POA Name" value={d.powerOfAttorneyHolderName} isDark={isDark} />
              <Field label="POA Aadhaar" value={d.powerOfAttorneyHolderAadhar} isDark={isDark} />
            </>
          )}
        </div>

        {/* COMPANY */}
        <Section title="Company Representative" />
        <div className="cw-form-grid">
          <Field label="Representative Name" value={d.companyRepresentativeName} isDark={isDark} />
          <Field label="Email" value={d.companyRepresentativeEmail} isDark={isDark} />
          <Field label="Phone Number" value={d.companyRepresentativePhone} isDark={isDark} />
        </div>

      </div>

      {/* IMAGE MODAL */}
      {previewImg && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.9)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
      padding: 10,
    }}
  >
    {/* ❌ CLOSE BUTTON */}
    <button
      onClick={() => setPreviewImg(null)}
      style={{
        position: "absolute",
        top: 16,
        right: 16,
        width: 34,
        height: 34,
        borderRadius: 10,
        cursor: "pointer",
        background: isDark
          ? "rgba(255,255,255,0.08)"
          : "rgba(255,255,255,0.2)",
        border: "1px solid rgba(255,255,255,0.3)",
        color: "#fff",
        fontSize: 16,
        backdropFilter: "blur(6px)",
      }}
    >
      ✕
    </button>

    {/* IMAGE CONTAINER */}
    <div
      style={{
        overflow: "auto",
        maxWidth: "100%",
        maxHeight: "100%",
      }}
    >
      <img
        src={previewImg}
        alt="preview"
        style={{
          maxWidth: "100%",
          maxHeight: "100%",
          borderRadius: 12,
          objectFit: "contain",
          touchAction: "manipulation", // ✅ mobile zoom
        }}
      />
    </div>
  </div>
)}
    </div>
  );
}   

export default ViewForm;